// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <div>
    <v-row wrap>
      <template v-for="(id, i) in ids">
        <v-col cols="12" md="6" :key="id">
          <v-card>
            <img
            @click="navigateImage(id)"
            class="image"
            v-bind:src="getUrl(id)"
            width="100%"
            style="max-width: 640px; cursor:pointer;"
            >
            <v-card-actions right>
              <v-spacer></v-spacer>
              <v-btn text color="red" @click="removeRef(i)">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </template>
    </v-row>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn fab dark class="green" @click="uploadClick" id="buttonFab" v-on="on">
          <v-progress-circular v-if="statusUploading" indeterminate></v-progress-circular>
          <v-icon v-else>add</v-icon>
        </v-btn>
      </template>
      <span>Upload Image</span>
    </v-tooltip>
    <input id="file-input" type="file" style="display: none;" @change="uploadFile" />
    <error-snackbar v-model="errorText"></error-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'
import {ENDPOINT} from '@/shared/constants'
import {checkPermission} from '@sdgsystems/vue-common/components/user'
import {PERMISSIONS} from '@sdgsystems/vue-common/components/constants'

export default {
  name: 'worker-photo',

  components: {
    ErrorSnackbar
  },

  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      categories: [],
      category: {},
      endpoint: ENDPOINT,
      errorText: '',
      item: this.value,
      photos: [],
      showDialog: false,
      statusUploading: false
    }
  },

  created () {
    this.getImages()
  },

  computed: {
    ...mapGetters([
      'accessRules'
    ]),

    canModify: function () {
      return checkPermission(this.accessRules, 'workers', PERMISSIONS.MODIFY)
    },

    ids: function () {
      if (this.item) {
        var photos = this.photos.map(e => e.id)
        var ids = this.item.photo
        photos = photos.filter(e => ids.indexOf(e) < 0)
        ids = ids.concat(photos)
        return ids
      }

      return {}
    }
  },

  watch: {
    value: function () {
      this.item = this.value
      this.getImages()
    },

    item: function () {
      this.$emit('input', this.item)
    }
  },

  methods: {
    checkAndCreateCategory: function () {
      var params = {}
      params.name = 'Things'
      ApiRequests.getImageCategories(params).then(r => {
        this.categories = r.data
        if (this.categories.length > 0) {
          this.category = this.categories[0]
        } else {
          var newCat = {}
          newCat.name = 'Things'
          newCat.description = 'Auto-generated: Images associated with workers & items'
          ApiRequests.postImageCategories(newCat, {}).then(r => {
            this.category = r.data
          }).catch(e => {
            this.errorText = 'Failed to create category'
          })
        }
      }).catch(e => {
        this.errorText = 'Failed to get categories'
      })
    },

    getImages: function () {
      this.photos = []

      for (var i = 0; i < this.item.tags.length; i++) {
        var tag = this.item.tags[i]
        if (tag !== '') {
          var params = {}
          params.tags = tag
          ApiRequests.getImages(params).then(r => {
            var data = r.data
            data = data.filter(e => this.photos.findIndex(f => f.id === e.id) < 0)
            this.photos = this.photos.concat(data)
          })
        }
      }
    },

    getUrl: function (id) {
      if (id) {
        return ENDPOINT + 'images/' + id + '/thumb'
      }
      return ''
    },

    navigateImage: function (id) {
      this.$router.push({
        name: 'imageEdit',
        params: { 'id': id }
      })
    },

    removeRef: function (index) {
      var id = this.ids[index]
      ApiRequests.deleteImage(id).then(r => {
        this.item.photo.splice(index, 1)
        this.$emit('change')
        this.getImages()
      }).catch(e => {
        this.errorText = 'Failed to delete image'
      })
    },

    uploadClick: function () {
      this.checkAndCreateCategory()
      document.getElementById('file-input').click()
    },

    uploadFile: function () {
      var files = event.target.files
      if (files.length > 0) {
        this.statusUploading = true
        var tags = this.$route.params.id
        var categories = this.category.id
        ApiRequests.postImage(files[0], tags, categories).then(r => {
          this.statusUploading = false
          if (this.item.photo === null) {
            this.item.photo = []
          }
          this.item.photo.push(r.data.id)
          this.$emit('change')
        }).catch(e => {
          this.errorText = 'Failed to save photo - ' + e
          this.statusUploading = false
        })
      }
    }
  }
}
</script>

<style scoped>
  #buttonFab {
    position: relative;
    overflow: hidden;
    position: fixed;
    bottom: 20px !important;
    right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/WorkerPhoto.vue